import React from "react"
import Template from "./template"
import PropTypes from "prop-types"
import Seo from "components/sections/seo"
import { graphql } from "gatsby"
import { getCorporationSchema, getSchemaWithFallback } from "../../utils/schemaHelpers"

const TemplateContainer = ({ data: { template } }) => {
  const fallbackSchema = getCorporationSchema()
  
  // Use Contentful json if present, otherwise use fallback
  const schema = getSchemaWithFallback(template.meta?.json, fallbackSchema)

  return (
    <>
      <Seo {...template.meta} id={template.id} schemaMarkup={schema} slug={template.slug} />
      <Template {...template} />
    </>
  )
}
TemplateContainer.props = {
  ...Template.props,
  meta: PropTypes.shape(Seo.props),
}
TemplateContainer.propTypes = {
  data: PropTypes.shape({
    template: PropTypes.shape(TemplateContainer.props),
  }),
}
export default TemplateContainer
export const query = graphql`
  query ResearchInterestFormTemplate($slug: String) {
    template: contentfulResearchInterestForm(slug: { eq: $slug }) {
      slug
      title
      htmlContent {
        htmlContent
      }
      meta: seoMetadata {
        canonical
        title
      }
    }
  }
`
